import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import {Link} from 'react-router-dom'
import {useAuth} from 'app/modules/auth'
import LecStatistics from './LecturerStatistics'
import StdStatistics from './StdStatistics'
import FinanceDashboard from './FinanceDashboard'
import {StudentCounts} from '../../../redux/Slice/studentSlice'
import EvaluationDashboard from './EvaluationDashboard'

const AdminDashboard = () => {
  const [loader, setLoader] = useState(true)
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {hasPermission} = useAuth()
  const [studentCounts, setStudentCounts] = useState<any>(null)
  const [showLecturerCharts, setShowLecturerCharts] = useState(false)
  const [showStudentCharts, setShowStudentCharts] = useState(false)
  const [showEvaluationCharts, setShowEvaluationCharts] = useState(false)
  const [showPaymentCharts, setShowPaymentCharts] = useState(false)

  useEffect(() => {
    dispatch(StudentCounts()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setStudentCounts(res.payload)
        setLoader(false)
      }
    })
  }, [])

  if (loader) return <Loader />

  return (
    <div className='container-fluid px-4'>
      {/* Student Statistics Cards */}
      {studentCounts && (
        <div className='row g-2'>
          {/* Entrance Students */}
          <div className='col-3'>
            <Link
              to={hasPermission('student-applications-list') ? '/student/kankor-apps' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-primary text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-file-alt mx-3' style={{fontSize: '3rem'}}></span>

                    <span className='fs-3'>{t('ONLINE.KANKOR_STUDENTS')}</span>
                  </div>

                  <div className='fs-1 fw-bold'>{studentCounts.kankor_apps}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Prospects */}
          <div className='col-3'>
            <Link
              to={hasPermission('student-applications-list') ? '/student/prospects' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-primary text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-user-plus mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('LABEL.PROSPECTS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.pros}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Online Prospects */}
          <div className='col-3'>
            <Link
              to={hasPermission('student-applications-list') ? '/student/online-pros' : '#'}
              className='text-decoration-none'
            >
              <div className='card text-white bg-primary shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-user-tag mx-3' style={{fontSize: '3rem'}}></span>

                    <span className='fs-3'>{t('LABEL.ONLINE_PROSPECTS')}</span>
                  </div>

                  <div className='fs-1 fw-bold'>{studentCounts.online_pros}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Total Applications */}
          <div className='col-3'>
            <Link
              to={
                hasPermission('student-applications-list')
                  ? '/student/student-applications-list'
                  : '#'
              }
              className='text-decoration-none'
            >
              <div className='card bg-primary text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-file-alt mx-3' style={{fontSize: '3rem'}}></span>

                    <span className='fs-3'>{t('DASHBOARD.TOTAL_APPLICATIONS')}</span>
                  </div>

                  <div className='fs-1 fw-bold'>{studentCounts.apps}</div>
                </div>
              </div>
            </Link>
          </div>

          {/* Total Students */}
          <div className='col-3'>
            <Link
              to={hasPermission('students-list') ? '/student/students-list' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-info text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-user-graduate mx-3' style={{fontSize: '3rem'}}></span>

                    <span className='fs-3'>{t('DASHBOARD.TOTAL_STUDENTS')}</span>
                  </div>

                  <div className='fs-1 fw-bold'>{studentCounts.students}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Online Students */}
          <div className='col-3'>
            <Link
              to={hasPermission('students-list') ? '/student/online-stds' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-info text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-globe mx-3' style={{fontSize: '3rem'}}></span>

                    <span className='fs-3'>{t('MENU.ONLINE_STD')}</span>
                  </div>

                  <div className='fs-1 fw-bold'>{studentCounts.online_stds}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Alumni */}
          <div className='col-2'>
            <Link
              to={
                hasPermission('student-applications-list') ? '/student/alumni-students-list' : '#'
              }
              className='text-decoration-none'
            >
              <div className='card bg-info text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-user-tie mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('DASHBOARD.TOTAL_ALUMNI')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.alumnies}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Planning */}
          <div className='col-2'>
            <Link
              to={hasPermission('timetable-list') ? '/academics/timetable-list' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-info shadow rounded-4 h-100 dashboard-card text-white'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-clock mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MENU.TIME_TABLES')}</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* News */}
          <div className='col-2'>
            <Link
              to={hasPermission('news-list') ? '/admin/news-list' : '#'}
              className='text-decoration-none'
            >
              <div className='bg-info text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-newspaper mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MENU.NEWS_AND_ANNOUNCEMENTS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.news}</div>
                </div>
              </div>
            </Link>
          </div>

          {/* Lecturers */}
          <div className='col-3'>
            <Link
              to={hasPermission('lecturers-list') ? '/admin/lecturers-list' : '#'}
              className='text-decoration-none'
            >
              <div
                className='card text-white shadow rounded-4 h-100 dashboard-card'
                style={{backgroundColor: '#124956'}}
              >
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span
                      className='fas fa-chalkboard-teacher mx-3'
                      style={{fontSize: '3rem'}}
                    ></span>
                    <span className='fs-3'>{t('MENU.LECTURERS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.lecturers}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Staff */}
          <div className='col-3'>
            <Link
              to={hasPermission('staff-list') ? '/admin/staffs' : '#'}
              className='text-decoration-none'
            >
              <div
                className='card text-white shadow rounded-4 h-100 dashboard-card'
                style={{backgroundColor: '#124956'}}
              >
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-user-cog mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MENU.NON_STAFF')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.staff}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* Contracts */}
          <div className='col-2'>
            <Link
              to={hasPermission('lecturer-contracts-list') ? '/admin/lecturer-contracts' : '#'}
              className='text-decoration-none'
            >
              <div
                className='card text-white shadow rounded-4 h-100 dashboard-card'
                style={{backgroundColor: '#124956'}}
              >
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-file-signature mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MENU.LECTURER_CONTRACTS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.contracts}</div>
                </div>
              </div>
            </Link>
          </div>

          {/* Meetings */}
          <div className='col-2'>
            <Link
              to={hasPermission('meeting-list') ? '/admin/meetings' : '#'}
              className='text-decoration-none'
            >
              <div className='card bg-light-teal text-white shadow rounded-4 h-100 dashboard-card'>
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-calendar-alt mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MEETING.MEETINGS')}</span>
                  </div>
                  <div className='fs-1 fw-bold'>{studentCounts.meetings}</div>
                </div>
              </div>
            </Link>
          </div>
          {/* My Meetings */}
          <div className='col-2'>
            <Link to={'/admin/my-meetings'} className='text-decoration-none'>
              <div
                className='card text-white shadow rounded-4 h-100 dashboard-card'
                style={{
                  background: 'linear-gradient(135deg, #2ab81d, #107707)',
                  border: 'none',
                }}
              >
                <div className='card-body d-flex justify-content-between align-items-center p-4'>
                  <div className='d-flex align-items-center'>
                    <span className='fas fa-calendar-check mx-3' style={{fontSize: '3rem'}}></span>
                    <span className='fs-3'>{t('MEETING.MY_MEETINGS')}</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      )}

      {/* <FinanceDashboard /> */}
      {hasPermission('finance-dashboard-view') && (
        <div className='card shadow-sm h-100 mt-5'>
          <div
            className='card-header bg-primary'
            style={{minHeight: '30px'}}
            onClick={() => setShowPaymentCharts(!showPaymentCharts)}
          >
            <h3 className='text-white mt-3'>{t('DASHBOARD.FINANCIAL_OVERVIEW')}</h3>
            <button type='button' className='btn btn-link btn-sm text-white'>
              <span className={`fa fa-caret-${showPaymentCharts ? 'down' : 'up'}`}></span>
            </button>
          </div>
          {showPaymentCharts && <FinanceDashboard />}
        </div>
      )}

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowLecturerCharts(!showLecturerCharts)}
        >
          <h3 className='text-white mt-3'>{t('DASHBOARD.PROFESSOR_OVERVIEW')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showLecturerCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showLecturerCharts && (
          <div className='card-body'>
            <LecStatistics />
          </div>
        )}
      </div>

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowStudentCharts(!showStudentCharts)}
        >
          <h3 className='text-white mt-3'>{t('DASHBOARD.STUDENTS_PROFILE')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showStudentCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showStudentCharts && (
          <div className='card-body'>
            <StdStatistics />
          </div>
        )}
      </div>

      <div className='card shadow-sm h-100 mt-5'>
        <div
          className='card-header bg-primary'
          style={{minHeight: '30px'}}
          onClick={() => setShowEvaluationCharts(!showEvaluationCharts)}
        >
          <h3 className='text-white mt-3'>{t('LABEL.FEEDBACK_AND_EVALUATION')}</h3>
          <button type='button' className='btn btn-link btn-sm text-white'>
            <span className={`fa fa-caret-${showEvaluationCharts ? 'down' : 'up'}`}></span>
          </button>
        </div>
        {showEvaluationCharts && <EvaluationDashboard />}
      </div>
    </div>
  )
}

export default AdminDashboard
